import { render, staticRenderFns } from "./Tiptap.vue?vue&type=template&id=75ed4ffe&"
import script from "./Tiptap.vue?vue&type=script&lang=ts&"
export * from "./Tiptap.vue?vue&type=script&lang=ts&"
import style0 from "./Tiptap.vue?vue&type=style&index=0&id=75ed4ffe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports